// extracted by mini-css-extract-plugin
export default {"container":"App_container__Xx-z+","rectangle":"App_rectangle__BNysy","pieChart":"App_pieChart__1I5FZ"};